import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { loginRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { normalizeAuthPhone } from "@/features/auth/utils/normalizeAuthPhone";

const LoginLayout = () => <Outlet />;

export const Route = createFileRoute("/_auth/_public/login")({
    component: LoginLayout,
    validateSearch: (search) => loginRouteSearchSchema.parse(search),
    beforeLoad: ({ search }) => {
        if (search.phoneOtp === "1" && search.phone) {
            const normalized = normalizeAuthPhone(search.phone);
            if (normalized) {
                throw redirect({
                    to: "/login/verify",
                    search: { phone: normalized },
                });
            }
        }
    },
});
